import React, { Fragment } from 'react'

import '../Styles/Banner.css'
import { useStateValue } from '../Utils/StateProvider'

function Banner() {
    const [{ banner }, payload] = useStateValue()
    return (
        <Fragment>
        {
            banner && new Date(banner.exp).getTime() > new Date().getTime() && (
                <div className='banner'>
                    <p>{banner.message}</p>
                </div>
            )
        }
        </Fragment>
    )
}

export default Banner
